<template>
  <!-- 项目验收 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6" :sm="12">
            <a-form-item label="项目编号">
              <a-input v-model="query.establishmentNo" placeholder="请输入项目编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="项目名称">
              <a-input v-model="query.establishmentName" placeholder="请输入项目名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="项目负责人">
              <a-input v-model="query.executeUserName" placeholder="请输入项目负责人" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="项目开始时间">
              <a-date-picker
                style="width: 100%"
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择项目开始时间"
                v-model="query.startTime"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="项目结束时间">
              <a-date-picker
                style="width: 100%"
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                show-time
                placeholder="请选择项目结束时间"
                v-model="query.endTime"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :md="10" :sm="20" style="display: flex">
            <a-form-item>
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="approval()" v-action:approva>审批</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="examine()">下载验收单</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table
      size="middle"
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="constructionStatus" slot-scope="text, record">
        <a-tag v-if="record.constructionStatus === 0" color="rgb(255, 99, 71)">未开始</a-tag>
        <a-tag v-if="record.constructionStatus === 1" color="#f98303">验收中</a-tag>
        <a-tag v-if="record.constructionStatus === 2" color="rgb(50, 205, 50)">验收完成</a-tag>
      </span>
      <span slot="approveStatus" slot-scope="text, record">
        <a-tag v-if="record.approveStatus === 0" color="rgb(255, 99, 71)">待审批</a-tag>
        <a-tag v-if="record.approveStatus === 1" color="rgb(50, 205, 50">审批通过 </a-tag>
        <a-tag v-if="record.approveStatus === 2" color="rgb(255, 99, 71)">审批不通过</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a-button :disabled="record.approveStatus == 1" key="back" @click="upload(record.id)">上传验收单</a-button>
      </span>
    </a-table>

    <!-- 审批 -->
    <a-modal
      title="审批"
      style="top: 20px"
      :width="800"
      :visible="approvalVisible"
      @ok="approvalHandle"
      @cancel="handleCancel"
    >
      <!-- <a-form class="tenant-form"> -->
      <a-form-model
        class="log-form"
        :model="engineeringProjectCheck"
        ref="engineeringProjectCheck"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item
          label="投资额"
          prop="investmentVolume"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="engineeringProjectCheck.approveStatus == 1"
        >
          <a-input v-model="engineeringProjectCheck.investmentVolume" />
        </a-form-model-item>
        <!-- <a-row v-for="(item, index) in natureList" :key="index">
          <a-col :span="8" style="margin-left: 53px">
            <a-form-model-item label="管道名称" prop="pipeline" :labelCol="{ span: 7 }" :wrapperCol="{ span: 15 }">
              <a-input v-model="engineeringProjectCheck.pipeline" style="width: 150px" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="管道公里数" prop="mileage" :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }">
              <a-input v-model="engineeringProjectCheck.mileage" style="width: 150px" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="margin-top: 7px">
            <a-button
              v-if="item.flag"
              size="small"
              type="primary"
              style="font-size: 12px"
              @click="natureclick(naturclicks)"
            >
              添加
            </a-button>
            <a-button v-if="!item.flag" size="small" type="primary" style="font-size: 12px" @click="deleteArr(index)">
              删除
            </a-button>
          </a-col>
        </a-row> -->
        <a-form-model-item :labelCol="labelCol" label="审批" :wrapperCol="wrapperCol" prop="approveStatus">
          <a-radio-group v-model="engineeringProjectCheck.approveStatus">
            <a-radio :value="1"> 通过 </a-radio>
            <a-radio :value="2"> 驳回 </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          label="审批结果"
          prop="approvalOpinion"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="engineeringProjectCheck.approveStatus == 1"
        >
          <a-input v-model="engineeringProjectCheck.approvalOpinion" />
        </a-form-model-item>
        <a-form-model-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectCheck.remark" />
        </a-form-model-item>
        <a-form-model-item label="附件上传" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div class="fileDiv">
            <ul>
              <li class="fileLi" v-for="item in engineeringProjectCheck.fileNames" :key="item.url">
                <div class="uploadDiv" @click="uploadFile(item)">
                  <a-icon type="file-done" style="cursor: pointer" />
                  {{ item.name }}
                </div>
                <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" />
              </li>
            </ul>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--上传验收单  -->
    <a-modal
      title="上传验收单"
      :visible="visibles"
      :width="700"
      :confirm-loading="confirmLoading"
      @ok="handleOks"
      @cancel="handleCancels"
    >
      <a-form-model
        class="log-form"
        :model="engineeringProjectCheck"
        ref="engineeringProjectCheck"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-form-model-item label="附件上传" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-upload-dragger name="file" :multiple="true" :customRequest="customReques" :showUploadList="false">
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              文件拖拽此处或
              <a>点击上传</a>
            </p>
          </a-upload-dragger>
          <div class="fileDiv">
            <ul>
              <li class="fileLi" v-for="item in engineeringProjectCheck.fileNames" :key="item.url">
                <div class="uploadDiv" @click="uploadFile(item)">
                  <a-icon type="file-done" style="cursor: pointer" />
                  {{ item.name }}
                </div>
                <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" />
              </li>
            </ul>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 查看验收单位 -->
    <a-modal title="工程验收单" style="text-align: center" :width="1000" :visible="visible" @cancel="handleCance">
      <template slot="footer">
        <div style="margin: 10px">
          <a-button key="submit" type="primary" @click="downloadWord"> 下载文档 </a-button>
        </div>
      </template>
      <div style="padding-left: 15%">
        <div class="bigTopBox"></div>
        <div class="bigTopBox">
          <span class="bigTopBox">
            <p style="">工程编码：{{ datas.establishmentNo }}</p>
            <p style="margin-right: 251px">工程名称：{{ datas.establishmentName }}</p>
          </span>
          <p style="text-align: right">年 月 日</p>
        </div>
        <div class="checkGrid">
          乙方(自来水有限公司)意见: <br />
          1、本安装工程按照林工蓝图安装完毕。 <br />
          2、本安装工程符合安装工程规范及要求。 <br />
          3、经双力验收合格,本安装工程所有安装设施及配套设施均无渗漏现象,现交付甲方使用,如有人为损坏或遗失均由甲方自行负责。
          <br />
          <p style="margin-left: 80%; margin-top: 50px">签字：</p>
        </div>
        <div class="grid">
          <div style="height: 50%">甲方(建设单位)意见:</div>
          <p style="margin-left: 80%; margin-top: 50px">签字：</p>
        </div>
        <div class="gridBox">
          <div class="gridItem">设计人员(签字):</div>
          <div class="gridItem">户籍人员(签字):</div>
          <div class="gridItem">施工人员(签字):</div>
          <div class="gridItem">监察人员(签字):</div>
          <div class="gridItem">测绘人员(签字)：</div>
        </div>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import axios from 'axios'
import mixinViewModule from '@/mixin/common'
const columns = [
  {
    title: '项目编码',
    dataIndex: 'establishmentNo',
  },
  {
    title: '项目名称',
    dataIndex: 'establishmentName',
  },
  {
    title: '实际结束时间',
    dataIndex: 'realityEndTime',
  },
  {
    title: '项目负责人',
    dataIndex: 'executeUserName',
  },
  {
    title: '验收状态',
    dataIndex: 'constructionStatus',
    scopedSlots: { customRender: 'constructionStatus' },
  },
  {
    title: '审批状态',
    dataIndex: 'approveStatus',
    scopedSlots: { customRender: 'approveStatus' },
  },
  {
    title: '审批结果',
    dataIndex: 'approvalOpinion',
  },
  {
    title: '投资额（元）',
    dataIndex: 'investmentVolume',
  },
  {
    title: '备注 ',
    dataIndex: 'remark',
  },
  {
    title: '操作',
    width: '120px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  components: {},
  mixins: [mixinViewModule],
  name: 'task',
  data() {
    return {
      exportDataUrl: 'pipe-network/engineering_project_checks/download',
      queryUrl: '/pipe-network/engineering_project_checks/page', //列表请求数据接口
      addOrUpdateUrl: '/pipe-network/engineering_project_checks', //新增
      // queryOneUrl: '/pipe-network/engineering_project_checks/list', //查询单条地址
      deleteUrl: '/pipe-network/engineering_project_checks', //删除
      uploadUrl: 'manager/file/resources/upload', // 上传文件URL
      query: {
        establishmentNo: '',
        establishmentName: '',
        executeUserName: '',
        startTime: '',
        endTime: '',
      }, // 查询参数
      naturclicks: 1,
      natureList: [
        {
          waterType: 0,
          flag: true,
        },
      ],
      // addOrUpdateVisible: false, // 新增修改是否可见
      visible: false,
      visibles: false,
      confirmLoading: false,
      curreId: 0,
      datas: [],
      datay: { name: '', establishmentName: '' },

      approvalVisible: false,
      engineeringProjectCheck: {
        id: 0,
        approveStatus: 0,
        investmentVolume: 0,
        constructionStatus: 0,
        remark: '',
        // pipeline: 0,
        // mileage: 0,
        fileNames: [],
        approvalOpinion: '',
      },
      rules: {
        investmentVolume: [
          { required: true, message: '请输入投资额', trigger: 'change' },
          {
            pattern: /^\d+$|^\d*\.\d+$/g,
            message: '请正确的投资额',
            trigger: 'change',
          },
        ],
        pipeline: [{ required: true, message: '请输入管径', trigger: 'change' }],
        mileage: [
          { required: true, message: '请输入管道公里数', trigger: 'change' },
          {
            pattern: /^\d+$|^\d*\.\d+$/g,
            message: '请正确的公里数',
            trigger: 'change',
          },
        ],
        approveStatus: [{ required: true, message: '请选择审批状态', trigger: 'change' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'change' }],
        approvalOpinion: [{ required: true, message: '请输入审批结果', trigger: 'change' }],
      },
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 18,
      },
      columns,
    }
  },
  created() {
    this.resetList()
  },
  methods: {
    deleteArr(index) {
      this.natureList.splice(index, 1)
    },
    natureclick(i) {
      console.log(i)
      let obj = {
        waterType: 0,
        flag: false,
      }
      if (this.natureList.length <= 2) {
        this.natureList.push(obj)
      }
    },
    //上传验收单
    upload(id) {
      this.engineeringProjectCheck.id = id
      this.$http.get(`/pipe-network/engineering_project_checks/${this.engineeringProjectCheck.id}`).then((res) => {
        this.engineeringProjectCheck.fileNames = res.data.fileNames
        this.engineeringProjectCheck.investmentVolume = res.data.investmentVolume
        this.engineeringProjectCheck.approveStatus = res.data.approveStatus
        this.engineeringProjectCheck.remark = res.data.remark
        // this.engineeringProjectCheck.pipeline = res.data.pipeline
        // this.engineeringProjectCheck.mileage = res.data.mileage
        this.engineeringProjectCheck.approvalOpinion = res.data.approvalOpinion
        if (res.code == 0) {
          this.engineeringProjectCheck.constructionStatus = 2
          this.visibles = true
        }
      })
    },
    handleOks(i) {
      if (i == 1) {
        this.engineeringProjectCheck.constructionStatus = i
      } else {
      }
      this.$http
        .put('/pipe-network/engineering_project_checks', {
          id: this.engineeringProjectCheck.id,
          ...this.engineeringProjectCheck,
        })
        .then((res) => {
          if (res.code == 0) {
            this.visibles = false
            this.queryList()
            if (i !== 1) {
              this.$message.success('修改成功')
            }
          } else {
            this.visibles = false
            return this.$message.error('修改失败！')
          }
        })
    },
    handleCancels() {
      this.visibles = false
    },
    downloadWord() {
      this.exportLoading = true
      const params = {
        responseType: 'arraybuffer',
        params: this.datay,
        headers: this.uploadHeader,
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .get(url, params)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = '验收表文档.doc'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.handleOks(1)
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    //审批
    approval() {
      if (this.selectedRows.length == 1) {
        this.engineeringProjectCheck.id = this.selectedRows[0]
        console.log(this.engineeringProjectCheck.id, '哈哈哈')
        this.approvalVisible = true
        this.$http.get(`/pipe-network/engineering_project_checks/${this.engineeringProjectCheck.id}`).then((res) => {
          this.engineeringProjectCheck.investmentVolume = res.data.investmentVolume
          this.engineeringProjectCheck.approveStatus = res.data.approveStatus
          this.engineeringProjectCheck.remark = res.data.remark
          // this.engineeringProjectCheck.pipeline = res.data.pipeline
          // this.engineeringProjectCheck.mileage = res.data.mileage
          this.engineeringProjectCheck.fileNames = res.data.fileNames
          this.engineeringProjectCheck.approvalOpinion = res.data.approvalOpinion
          console.log(res.data)
          // this.engineeringProjectCheck.setFieldsValue(data)
        })
      } else if (this.selectedRows.length == 0) {
        return this.$message.warn('请选择一条要审批的事件')
      } else {
        return this.$message.warn('只能选择一条要审批的事件')
      }
    },
    // 确认审批
    approvalHandle() {
      this.$refs.engineeringProjectCheck.validate((valid) => {
        if (valid) {
          this.$http
            .put(`${this.addOrUpdateUrl}`, { id: this.engineeringProjectCheck.id, ...this.engineeringProjectCheck })
            .then((res) => {
              if (res.code == 0) {
                this.approvalVisible = false
                this.queryList()
                return this.$message.success(res.message)
              } else {
                this.approvalVisible = false
                return this.$message.warn(res.message)
              }
            })
          this.$refs.engineeringProjectCheck.resetFields()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 查看验收单位
    examine() {
      if (this.selectedRows.length == 1) {
        this.engineeringProjectCheck.id = this.selectedRows[0]
        console.log(this.engineeringProjectCheck.id, '哈哈哈')
        this.visible = true
        this.$http.get(`/pipe-network/engineering_project_checks/${this.engineeringProjectCheck.id}`).then((res) => {
          this.datas = res.data
          ;(this.datay = { name: res.data.establishmentName, establishmentNo: res.data.establishmentNo }),
            (this.engineeringProjectCheck.investmentVolume = res.data.investmentVolume)
          this.engineeringProjectCheck.approveStatus = res.data.approveStatus
          this.engineeringProjectCheck.remark = res.data.remark
          this.engineeringProjectCheck.fileNames = res.data.fileNames
          this.engineeringProjectCheck.approvalOpinion = res.data.approvalOpinion
          console.log(this.engineeringProjectCheck, '有没有')
        })
      } else if (this.selectedRows.length == 0) {
        return this.$message.warn('请选择一条要下载的事件')
      } else {
        return this.$message.warn('只能选择一条要下载的事件')
      }
    },
    //取消
    handleCance() {
      this.visible = false
    },
    handleCancel() {
      this.$refs.engineeringProjectCheck.resetFields()
      this.approvalVisible = false
    },
    //文件上传
    customReques(data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile(formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {},
        params: {},
        data: formData,
      })
        .then((response) => {
          if (response.code === 0) {
            let obj = {
              url: response.data.url,
              name: response.data.fileName,
            }
            this.engineeringProjectCheck.fileNames.push(obj)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    uploadFile(item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    deleteFile(url) {
      let index = this.engineeringProjectCheck.fileNames.findIndex((item) => {
        return item.url == url
      })
      console.log(index)
      this.engineeringProjectCheck.fileNames.splice(index, 1)
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
table {
  width: 85%;
  text-align: left;
  line-height: 40px;
}
.checkGrid {
  padding: 10px;
  width: 85%;
  height: 250px;
  text-align: left;
  border: 1px solid;
  // border-bottom: none;
}
.grid {
  width: 85%;
  height: 250px;
  text-align: left;
  border: 1px solid;
  border-top: none;
  padding: 10px;
}
.gridBox {
  width: 85%;
  height: 250px;
  text-align: left;
  border: 1px solid;
  border-top: none;
  display: flex;
  // justify-content: space;
  padding-right: 200px;
  flex-wrap: wrap;
  .gridItem {
    margin-top: 25px;
    width: 180px;
    margin-left: 25px;
  }
}

.bigTopBox {
  width: 85%;
  display: flex;
  justify-content: space-between;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
